module.exports = __webpack_public_path__ + "img/4.3c7b6179.png";